
import logger from '@/modules/Logger';
import UAParser from 'ua-parser-js';

function pollingDeviceChangeEvent(callback) {
  // Declare a variable to hold the polling interval ID (for cleanup)
  let pollTimeout = null;
  // Track the list of devices to compare for changes
  let lastDevices = null;

  let eventStopped = false;

  // Function to check for device changes
  function checkForDeviceChange() {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        // Dont trigger the initial value assignment, its for initialization only
        if (lastDevices !== null) {
          let deviceListChanged = devices.length !== lastDevices.length ||
          !devices.every((device, index) => device.deviceId === lastDevices[index].deviceId);
          
          // Compare the current list of devices with the last one
          if (deviceListChanged) {
            callback();
          }
        }

        // Update the lastDevices array
        lastDevices = devices;

        // use setTimeout instead of setInterval 
        // to make sure previous process is already done
        // before starting another one
        if (!eventStopped) {
          pollTimeout = setTimeout(checkForDeviceChange(), 3000);
        }
      })
      .catch((error) => {
        stopEvent();
        logger.error('Error enumerating devices:', error);
      });
  }

  function stopEvent() {
    eventStopped = true;
    clearTimeout(pollTimeout);
  }

  // start polling
  checkForDeviceChange();

  // Return a function to stop the polling manually
  return stopEvent;
}

export default function deviceChangeEvent(callback) {
  // First, check if the native 'devicechange' event is supported
  let ua = new UAParser();
  let osName = ua.getOS().name;
  
  if (osName !== 'Android') {
    // Use the native event if supported
    navigator.mediaDevices.addEventListener('devicechange', callback);

    // Return a function to remove the event listener if needed
    return function stopEvent() {
      navigator.mediaDevices.removeEventListener('devicechange', callback);
    };
  } else {
    logger.debug('Devicechange event not supported; fallback to polling.', { browser: ua.getBrowser() });
    return pollingDeviceChangeEvent(callback);
  }
}
